import GlobalBanner from "./GlobalBanner";
export default GlobalBanner;
